module.exports = __webpack_public_path__ + "static/media/solo_hymen6.8671fd0b.svg";